import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLicenseStatus } from 'hooks/useLicenseStatus';
import { LicenseExpiredOverlay } from 'components/ui';
import { ROUTES } from 'constants/index';

export const LicenseOverlayWrapper: React.FC = () => {
  const { isExpired, hasLicense, companyData } = useLicenseStatus();
  const location = useLocation();
 
  const isOnDashboard = location.pathname === ROUTES.DASHBOARD;

  // Show overlay if no license or license expired, but not on dashboard
  if ((!hasLicense || isExpired) && !isOnDashboard) {
    return null; // Let the dashboard handle the display
  }

  return null;
};
